import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProcessHero = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-primary via-trust to-primary overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          {/* Content */}
          <div className="text-white space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                  <Icon name="Hammer" size={24} color="var(--color-accent-foreground)" strokeWidth={2.5} />
                </div>
                <span className="font-inter text-accent font-semibold text-lg">Processo Artesanal</span>
              </div>
              
              <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                A Arte de Criar
                <span className="block text-accent">Móveis Únicos</span>
              </h1>
              
              <p className="text-xl text-white/90 leading-relaxed max-w-2xl">
                Cada peça PH Móveis nasce de um processo artesanal meticuloso, onde tradição e inovação se encontram para criar móveis que transcendem o tempo e contam histórias únicas.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Play"
                iconPosition="left"
                className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-lg"
              >
                Ver Processo Completo
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Download"
                iconPosition="left"
                className="border-white text-white hover:bg-white hover:text-primary"
              >
                Baixar Guia de Processos
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-white/20">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">25+</div>
                <div className="text-sm text-white/80">Anos de Experiência</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">150+</div>
                <div className="text-sm text-white/80">Horas por Peça</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">100%</div>
                <div className="text-sm text-white/80">Feito à Mão</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://images.unsplash.com/photo-1581539250439-c96689b516dd?w=800&h=600&fit=crop"
                alt="Artesão trabalhando em móvel de madeira"
                className="w-full h-[600px] object-cover"
              />
              
              {/* Máscara preta com transparência uniforme */}
              <div className="absolute inset-0 bg-black/40"></div>
              
              {/* Play Button Overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <button className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors duration-300 group">
                  <Icon name="Play" size={32} color="var(--color-primary)" className="ml-1 group-hover:scale-110 transition-transform duration-300" />
                </button>
              </div>
            </div>

            {/* Floating Cards */}
            <div className="absolute -top-6 -left-6 bg-white rounded-xl p-4 shadow-xl">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <Icon name="TreePine" size={20} color="white" />
                </div>
                <div>
                  <div className="font-semibold text-primary">Madeira Premium</div>
                  <div className="text-sm text-text-secondary">Selecionada à mão</div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-4 shadow-xl">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={20} color="var(--color-accent-foreground)" />
                </div>
                <div>
                  <div className="font-semibold text-primary">Certificado</div>
                  <div className="text-sm text-text-secondary">Qualidade garantida</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <Icon name="ChevronDown" size={24} />
      </div>
    </section>
  );
};

export default ProcessHero;